
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  emits: ["modify"],
  props: {
    name: String,
    value: { type: Boolean, required: true },
    disabled: Boolean,
    id: String,
  },
});
